import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { DProvider } from './context/DContext';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

// Platform detection and setup
if (Capacitor.isNativePlatform()) {
  // Add capacitor class to body for CSS targeting
  document.body.classList.add('capacitor');
  
  // Configure status bar
  StatusBar.setStyle({ style: Style.Light });
  StatusBar.setBackgroundColor({ color: '#012970' });
  StatusBar.setOverlaysWebView({ overlay: true });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <DProvider>
    <App />
    </DProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
